import React, { Component } from 'react';
import { ButtonToolbar, Button, Grid, Row, Col, FormGroup, ControlLabel, Checkbox } from 'react-bootstrap';
import Select from "react-select";

import { PropTypes } from 'prop-types';

export class DayTimesheetParameters extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        const lineDirections = [
            { value: 0, label: "Automática" },
            { value: 1, label: "Ida" },
            { value: 2, label: "Volta" },
            { value: 3, label: "Circular" },
        ];

        let parameterLineDirection = undefined;
        let parameterUseDayTypesExceptions = true;
        let parameterUseTripsExceptions = true;
        let parameterUseTripNotesAsExceptions = false;
        let parameterUsePathNotesAsExceptions = false;
        let parameterGenerateAutomaticExceptions = true;
        let parameterUseSeasonsExceptions = false;
        let parameterShowSeasonsExceptionsIntervals = false;
        let parameterSeasonsToIgnore = undefined;

        if (undefined !== props.parameters && null !== props.parameters) {
            parameterLineDirection = lineDirections.find(x => x.value === props.parameters.lineDirection);
            parameterUseDayTypesExceptions = undefined === props.parameters.useDayTypesExceptions ? parameterUseDayTypesExceptions : props.parameters.useDayTypesExceptions;
            parameterUseTripsExceptions = undefined === props.parameters.useTripsExceptions ? parameterUseTripsExceptions : props.parameters.useTripsExceptions;
            parameterUseTripNotesAsExceptions = undefined === props.parameters.useTripNotesAsExceptions ? parameterUseTripNotesAsExceptions : props.parameters.useTripNotesAsExceptions;
            parameterUsePathNotesAsExceptions = undefined === props.parameters.usePathNotesAsExceptions ? parameterUsePathNotesAsExceptions : props.parameters.usePathNotesAsExceptions;
            parameterGenerateAutomaticExceptions = undefined === props.parameters.GenerateAutomaticExceptions ? parameterGenerateAutomaticExceptions : props.parameters.GenerateAutomaticExceptions;
            parameterUseSeasonsExceptions = undefined === props.parameters.useSeasonsExceptions ? parameterUseSeasonsExceptions : props.parameters.useSeasonsExceptions;
            parameterShowSeasonsExceptionsIntervals = undefined === props.parameters.showSeasonsExceptionsIntervals ? parameterShowSeasonsExceptionsIntervals : props.parameters.showSeasonsExceptionsIntervals;
            parameterSeasonsToIgnore = undefined === props.parameters.seasonsToIgnore ? parameterSeasonsToIgnore : props.parameters.seasonsToIgnore;
        }

        this.state = {
            parameters: this.props.parameters,
            dependencies: {
                lineDirections: lineDirections,
                seasons: [],
            },
            form: {
                show: false,
                lineDirection: undefined === parameterLineDirection ? lineDirections[0] : parameterLineDirection,
                useDayTypesExceptions: parameterUseDayTypesExceptions,
                useTripsExceptions: parameterUseTripsExceptions,
                useTripNotesAsExceptions: parameterUseTripNotesAsExceptions,
                usePathNotesAsExceptions: parameterUsePathNotesAsExceptions,
                GenerateAutomaticExceptions : parameterGenerateAutomaticExceptions,
                useSeasonsExceptions: parameterUseSeasonsExceptions,
                showSeasonsExceptionsIntervals: parameterShowSeasonsExceptionsIntervals,
                seasonsToIgnore: parameterSeasonsToIgnore,
            },
        };
    }

    componentDidMount() {
        this.context.addEditionObserver(this);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    reduceSeasons(output, edition) {
        if (!output.includes(edition)) {
            output.push(edition);
        }

        return output;
    }

    updatePlanning(edition) {
        const { dependencies } = this.state;

        dependencies.seasons = edition.objects
            .planning
            .map(edition => edition.name.substring(0, edition.name.lastIndexOf('[')).trim())
            .reduce(this.reduceSeasons, [])
            .sort((a, b) => a.localeCompare(b));

        this.setState({
            dependencies: dependencies
        });
    }

    // -----------------------

    onParameterData() {
        const { parameters, form } = this.state;

        const newParameters = {
            lineDirection: null === form.lineDirection ? 0 : form.lineDirection.value,
            useDayTypesExceptions: form.useDayTypesExceptions,
            useTripsExceptions: form.useTripsExceptions,
            useTripNotesAsExceptions: form.useTripNotesAsExceptions,
            usePathNotesAsExceptions: form.usePathNotesAsExceptions,
            GenerateAutomaticExceptions: form.GenerateAutomaticExceptions,
            useSeasonsExceptions: form.useSeasonsExceptions,
            showSeasonsExceptionsIntervals: form.showSeasonsExceptionsIntervals,
            seasonsToIgnore: form.seasonsToIgnore,
        };

        const baseParameters = (undefined === parameters || null === parameters) ? { id: 0 } : parameters;
        this.props.onParameterData(Object.assign(baseParameters, newParameters), true);
    }

    onChangeCheckboxValue(target) {
        const { form } = this.state;

        form[target] = !form[target];

        this.setState({
            form: form
        });
    }

    onChangeValue(e, target) {
        const { form } = this.state;

        if ("" === e.target.validationMessage) {
            form[target] = e.target.value;
        }

        this.setState({
            form: form
        });
    }

    onSelectValue(e, target) {
        const { form } = this.state;

        form[target] = e;

        this.setState({
            form: form
        });
    }

    // -----------------------

    renderShowSeasonsExceptionsIntervals(form) {
        if (!form.useSeasonsExceptions) {
            return null;
        }

        return (
            <Checkbox checked={form.showSeasonsExceptionsIntervals}
                onChange={() => this.onChangeCheckboxValue("showSeasonsExceptionsIntervals")}>
                Apresentar os Intervalos das Exceções das Épocas do Ano
            </Checkbox>
        );
    }

    renderSeasonsToIgnore(seasons, form) {
        if (!form.useSeasonsExceptions) {
            return null;
        }

        return (
            <FormGroup>
                <ControlLabel className="margin-top-15">Excepto - Épocas do Ano</ControlLabel>
                <Select
                    className="custom-multiselect"
                    placeholder="Épocas do Ano"
                    noOptionsMessage={() => "Sem Épocas Configuradas"}
                    onChange={(e) => this.onSelectValue(e, "seasonsToIgnore")}
                    options={seasons}
                    isMulti={true}
                    isClearable={true}
                    isOptionSelected={function (a) {
                        if (!Array.isArray(form.seasonsToIgnore)) {
                            return false;
                        }

                        return form.seasonsToIgnore.includes(a);
                    }}
                    getOptionValue={value => value}
                    getOptionLabel={label => label}
                    value={form.seasonsToIgnore} />
            </FormGroup>
        );
    }

    render() {
        const { form, dependencies } = this.state;

        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <ControlLabel className="margin-top-15">Direção da Linha</ControlLabel>
                                <Select
                                    className="custom-multiselect"
                                    placeholder="Direção da Linha"
                                    noOptionsMessage={() => "Sem Direções de Linha Configuradas"}
                                    onChange={(e) => this.onSelectValue(e, "lineDirection")}
                                    options={dependencies.lineDirections}
                                    isMulti={false}
                                    isClearable={false}
                                    isOptionSelected={function (a) {
                                        return form.lineDirection === a;
                                    }}
                                    getOptionValue={value => value}
                                    getOptionLabel={label => label.label}
                                    value={form.lineDirection} />
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col sm={12}>
                            <FormGroup>
                                <ControlLabel className="margin-top-15">Exceções</ControlLabel>

                                <Checkbox checked={form.GenerateAutomaticExceptions}
                                    onChange={() => this.onChangeCheckboxValue("GenerateAutomaticExceptions")}>
                                    Apresentar Exceções Automáticas
                                </Checkbox>

                                <Checkbox checked={form.useDayTypesExceptions}
                                    onChange={() => this.onChangeCheckboxValue("useDayTypesExceptions")}>
                                    Apresentar Exceções de Tipo de Dia
                                </Checkbox>

                                <Checkbox checked={form.useTripsExceptions}
                                    onChange={() => this.onChangeCheckboxValue("useTripsExceptions")}>
                                    Apresentar Exceções de Viagens
                                </Checkbox>

                                <Checkbox checked={form.useSeasonsExceptions}
                                    onChange={() => this.onChangeCheckboxValue("useSeasonsExceptions")}>
                                    Apresentar Exceções de Épocas do Ano
                                </Checkbox>

                                <Checkbox checked={form.useTripNotesAsExceptions}
                                    onChange={() => this.onChangeCheckboxValue("useTripNotesAsExceptions")}>
                                    Apresentar Notas de Viagem como Exceção
                                </Checkbox>

                                <Checkbox checked={form.usePathNotesAsExceptions}
                                    onChange={() => this.onChangeCheckboxValue("usePathNotesAsExceptions")}>
                                    Apresentar Notas de Percurso como Exceção
                                </Checkbox>

                                {this.renderShowSeasonsExceptionsIntervals(form)}
                            </FormGroup>

                            {this.renderSeasonsToIgnore(dependencies.seasons, form)}
                        </Col>
                    </Row>
                </Grid>

                <ButtonToolbar>
                    <Button bsStyle="default" onClick={() => this.onParameterData()}>GUARDAR</Button>
                    <Button bsStyle="default" onClick={() => this.props.onCancel()}>FECHAR</Button>
                </ButtonToolbar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/bussched/layoutConfigurations/parameters/DayTimesheetParameters.js